import { render } from "./cSidebar.vue?vue&type=template&id=1acf089e&scoped=true"
import script from "./cSidebar.vue?vue&type=script&lang=js"
export * from "./cSidebar.vue?vue&type=script&lang=js"

import "./cSidebar.vue?vue&type=style&index=0&id=1acf089e&scoped=true&lang=css"

import exportComponent from "C:\\EPS_Code\\Clockwork_FrontandBack\\ClockWork.Vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1acf089e"]])

export default __exports__